import CutwiseAPIClient, { METHOD_GET, METHOD_POST } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';
import { CustomGradeCode } from '@/customGrading/constants/customGradeCodes';
import { GradeAttributeModel } from '@/customGrading/entity/GradeAttribute';
import GradeDictEntry from '@/customGrading/entity/GradeDictEntry';
import { ProductCustomGradeInfoModel } from '@/customGrading/entity/ProductCustomGradeInfo';
import Diamond from '@/product/entity/Diamond';

export const PATH_CUSTOMGRADE = 'api/v2/customgrade';

export default class CustomGradingAPI {
  fetchCustomGradeAttribute(attribute: CustomGradeCode): Promise<QueryResult<GradeAttributeModel>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(`${PATH_CUSTOMGRADE}/attribute/${attribute}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  fetchCustomGradingDataForProducts(products: Diamond[], gradingFieldKey: CustomGradeCode) {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(PATH_CUSTOMGRADE)
      .addQueryStringParam(
        'product',
        products.map((p) => p.id),
      )
      .addQueryStringParam('attribute', gradingFieldKey);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery<ProductCustomGradeInfoModel[]>(query);
  }

  changeCustomGradeForProduct(
    product: Diamond,
    resultedGrade: GradeDictEntry,
    gradingFieldKey: CustomGradeCode,
    lastProductPosition: Nullable<number>,
    sessionId: Nullable<string>,
  ) {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_POST)
      .path(PATH_CUSTOMGRADE)
      .body({
        attribute: gradingFieldKey,
        product: product.id,
        grade: {
          grade: resultedGrade.id,
          session: sessionId,
          initialPosition: lastProductPosition,
        },
      });

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
